<template>
  <div class="container-fluid">
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">
        Vendor
        <sup>*</sup>
      </label>
      <div class="col-sm-5 pr-5">
        <multiselect
          v-model="profile.selected_profile"
          :options="vendorList"
          :searchable="true"
          ref="multiselect"
          label="vendor_name"
          track-by="vendor_id"
          open-direction="bottom"
          placeholder="Vendor"
          class="form-control multi-dropdown select_filter"
          selectLabel
          deselectLabel
          selectedLabel
          autocomplete="off"
          tagPlaceholder="Press enter to create new vendor"
          style="max-height: 40px"
          :multiple="false"
          id="vendor"
          :taggable="false"
          @select="vendorChanged"
        >
          <template slot="noResult">
            <div>No vendor found..Hence create a new one</div>
          </template>
        </multiselect>
      </div>
      <div class="col-md-2">
        <button
          class="btn btn-primary"
          style="font-size: 12px"
          @click="addNewVendor()"
        >
          Create New
        </button>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Country <sup>*</sup></label>
      <div class="col-sm-7 pr-5">
        <input
          v-on:keydown.enter.prevent
          type="text"
          name="entityId"
          v-model="profile.country_code"
          class="form-control"
          id="entityId"
          placeholder="Country code"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Annual Sales Goal</label>
      <div class="col-sm-7 pr-5">
        <input
          type="number"
          name="annualGoal"
          v-model="profile.annual_goal"
          class="form-control"
          id="entityId"
          placeholder="Annual goal"
          autocomplete="off"
          min="0"
          onkeypress="return event.charCode != 45"
        />
      </div>
    </div>
    <div class="form-group row">
					<label class="col-sm-3 col-form-label">Go Retail Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="profile.go_retail"
							:options="contacts_list"
							:searchable="true"
							@search-change="updateName"
							ref="multiselect"
							track-by="email"
							:custom-label="customLabel"
							open-direction="bottom"
							placeholder="Go retail contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							tagPlaceholder="Press enter to create new contact"
							autocomplete="off"
							style="max-height:40px;"
							:multiple="false"
							:loading="retailLoader"
							id="retail"
							:taggable="true"
							@select = "addNew($event,'retail', index)"
							@tag="addNew($event,'retail', index)"
						>
							<template slot="noResult">
								<div @click="addNew('retail', index)">Add new retail contact</div>
							</template>
						</multiselect>
					</div>
		</div>
    <div class="form-group row">
					<label class="col-sm-3 col-form-label">Go Marketing Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="profile.go_marketing"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							label="first_name"
							:custom-label="customLabel"
							track-by="email"
							open-direction="bottom"
							placeholder="Go marketing contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							style="max-height:40px;"
							:multiple="false"
							id="market"
							:loading = "marketLoader"
							tagPlaceholder="Press enter to create new contact"
							:taggable="true"
							@select = "addNew($event,'market', index)"
							@tag="addNew($event,'market', index)"
						>
							<template slot="noResult">
								<div @click="addNew('market', index)">Create new market contact</div>
							</template>
						</multiselect>
					</div>
				</div>
        
				<div class="form-group row">
					<label class="col-sm-3 col-form-label">Go Ops Contact</label>
					<div class="col-sm-7 pr-5">
						<multiselect
							v-model="profile.go_ops"
							:options="contacts_list"
							:searchable="true"
							ref="multiselect"
							:custom-label="customLabel"
							label="first_name"
							track-by="email"
							open-direction="bottom"
							placeholder="Go ops contact"
							class="form-control multi-dropdown select_filter"
							selectLabel
							deselectLabel
							selectedLabel
							autocomplete="off"
							tagPlaceholder="Press enter to create new contact"
							style="max-height:40px;"
							:multiple="false"
							id="ops"
							:loading="opsLoader"
							:taggable="true"
							@select = "addNew($event,'ops', index)"
							@tag="addNew($event,'ops', index)"
						>
							<template slot="noResult">
								<div @click="addNew('ops', index)">Create new ops contact</div>
							</template>
						</multiselect>
					</div>
				</div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">
        Partner UUID
        <!-- <sup>*</sup> -->
      </label>
      <div class="col-sm-7 pr-5">
          <input
          type="text"
          name="partner_uuid"
          v-model="profile.partner_uuid"
          class="form-control"
          id="partner_uuid"
          placeholder="Partner UUID"
          autocomplete = "off"
          min="0"
          style="height:40px;"
        >
      </div>
    </div>
    <div class="form-group row" style="padding-left: 0px">
      <div class="col-sm-3 col-form-label">
        <label class="form-check-label" for="exampleCheck1">Active</label>
      </div>
      <div class="col-form-label" style="margin-left: 15px; margin-right: 30px">
        <div class="form-check d-inline-block" style="display: flex !important">
          <input
            type="checkbox"
            v-model="profile.active"
            :disabled="
              profile.active &&
              profile.disable_date != '' &&
              profile.disable_date != null
            "
            value="true"
            style="padding-bottom: 5px"
            class="form-check-input"
            id="exampleCheck1"
            autocomplete="off"
            @click="activeValueChange($event)"
          />
        </div>
      </div>
      <div
        class="col-sm-7 form-group"
        v-if="profile.showDate"
        style="padding: 0px"
      >
        <div class="form-group col" style="padding: 0px">
          <div class="form-group row" style="margin: 0px">
            <div
              class="col-form-label align-self-center"
              style="
                padding-top: 0px;
                margin: 0px;
                padding: 0px;
                margin-top: 0px;
              "
              :style="
                ifDisabledOnPastDate(profile.disable_date)
                  ? 'margin-top:5px'
                  : 'margin-top:-4px'
              "
            >
              <label class="form-check-label" for="exampleCheck1">{{
                ifDisabledOnPastDate(profile.disable_date)
                  ? "Disabled On " + getFormattedDate(profile.disable_date)
                  : "Disables On"
              }}</label>
            </div>
            <div class="col-sm-5" style="padding-top: 0px">
              <b-form-datepicker
                :id="index + '_disable'"
                name="disable_date"
                placeholder="MM/DD/YYYY"
                class="date_wrapper"
                v-model="profile.disable_date"
                menu-class="w-100"
                size="sm"
                :date-format-options="{
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }"
                calendar-width="180%"
                :hide-header="true"
                :today-button="false"
                :min="min_date_disable"
                locale="en"
                v-if="!ifDisabledOnPastDate(profile.disable_date)"
                @input="updateTheValidation(-1)"
              ></b-form-datepicker>
            </div>
            <div
              class="col-sm-3"
              style="margin: 0px; padding: 0px"
              v-if="
                !ifDisabledOnPastDate(profile.disable_date) &&
                profile.disable_date &&
                profile.active
              "
            >
              <button
                class="btn btn-primary"
                style="font-size: 12px"
                @click="deleteDate"
              >
                Delete Date
              </button>
            </div>
          </div>
          <!-- <div>
									<p
										style="font-size:13px;color:red;padding-top:10px"
										v-if="!ifDisabledOnPastDate(profile.disable_date)"
									>(Update will happen at 11:59pm on selected date)</p>
								</div> -->
        </div>
      </div>
      <div
        class="col-sm-1"
        style="text-align: center"
        v-if="
          profile.showDate &&
          profile.disable_date &&
          !ifDisabledOnPastDate(profile.disable_date)
        "
      >
        <p style="font-size: 13px; color: orange">Pending InActive</p>
      </div>
    </div>

    <div
      class="row"
      style="padding-top: 10px"
      v-if="!ifDisabledOnPastDate(profile.disable_date) && profile.showDate"
    >
      <div class="msg-style">
        <p class="msg-text-style" style="">
          {{ "Update will happen at 11:59pm on selected date" }}
        </p>
      </div>
    </div>
    <div
      class="no-data-style row"
      style="padding-top: 10px; margin-left: 15px"
      v-if="index == noDateForActiveFalse && profile.showDate"
    >
      Provide Date to disable the profile
    </div>
    <AddContactModal
        v-if="openAddNewContactModal"
        @closeAddContactModal="closeAddContactModal"
        :addedNewName="addedNewName"
        :editObj = "editObj"
      />
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from 'moment';
import AddContactModal from "@/components/account-management/AddContactModal";
export default {
  name: "AmazonVendorData",
  props: ["index", "vendorList", "profile",
			"noDateForActiveFalse"],
  components: { Multiselect, AddContactModal },
  data() {
    return {
      openAddNewContactModal:false,
      contacts_list:[],
      addedNewName: "",
      addedType: "",
      type:'',
      editObj:{}
    };
  },
  
  computed: {
    min_date_disable() {
      //only allow future dates, will prevent past as well as current date from selection
      return moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
    }
  },
  mounted(){
    this.getContactsList()
  },
  methods: {
    moment,
    customLabel(data) {
      if (!data.last_name) {
        return data.first_name;
      } else {
        return data.first_name + " " + data.last_name;
      }
    },
    closeAddContactModal(data, type) {
      this.addedNewName = "";
      this.openAddNewContactModal = false;

      if (data.length) {
        switch (this.addedType) {
          case "client":
            this.profile.client_main_contact = (type == 'reset' ? '' : data[0])
            break;
          case "market":
            this.profile.go_marketing = (type == 'reset' ? '' : data[0])
            break;
          case "ops":
            this.profile.go_ops = (type == 'reset' ? '' : data[0])
            break;
          case "retail":
            this.profile.go_retail = (type == 'reset' ? '' : data[0])
            break;
        }
      }
      else{
        switch (this.addedType) {
          case "client":
            this.profile.client_main_contact = null
            break;
          case "market":
            this.profile.go_marketing = null
            break;
          case "ops":
            this.profile.go_ops = null
            break;
          case "retail":
            this.profile.go_retail = null
            break;
        }
      }
      
      if(type && type == 'edit'){
        let replaceVal = this.contacts_list.find((e) => e.id == data[0].id)
        if(replaceVal){
          let indx = this.contacts_list.indexOf(replaceVal)
          this.contacts_list.splice(indx, 1, data[0])
        }
      }
      else if (type == 'add'){
				this.contacts_list.push(data[0])
      }


      this.addedNewName = ''
      this.editObj = {}
    },
    getContactsList() {
      let payload = { q: "" };
      let vm = this;
      this.$store
        .dispatch("accounts/getContactsList", payload)
        .then(res => {
          vm.contacts_list = res;
        });
    },
    addNew(val, type) {
      if(val && typeof val == "object"){
        this.editObj = val;
        this.addedNewName = val.first_name;
      }
      else{
        this.addedNewName = val;
      }
      this.openAddNewContactModal = true;
      this.addedType = type;
    },
    activeValueChange(val) {
      if (!val.currentTarget.checked) {
        this.$emit("updateDisableDate", this.index, true);
      } else {
        this.$emit("updateDisableDate", this.index, false);
      }
    },
    ifDisabledOnPastDate(disableDate) {
      let x = moment(disableDate).isSameOrBefore(moment());
      return x;
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    setDateFormat(date) {
      return moment().format("MM/DD/YYYY");
    },
    updateTheValidation(data) {
      this.$emit("dateProvideDisableVAlidation", data);
    },
    deleteDate() {
      this.$emit("removeDate", this.index);
    },
    vendorChanged(e) {
      // if (
      //   this.profile.type == "Vendor" &&
      //   Object.keys(this.profile.selected_profile).length
      // ) {
      //   this.$emit('convertToUniqueVendorDataSet',
      //     this.profile.selected_profile.id.toString().trim(),
      //     'remove'
      //   );
      // }
      let go_marketing = null
      let go_retail = null
      let go_ops = null
      if(this.contacts_list.length && e){
        if(e.go_retail){
          go_retail = this.contacts_list.filter(data=> data.id == e.go_retail)
          go_retail = go_retail && go_retail.length? go_retail[0] : null
        }
        if(e.go_marketing){
          go_marketing = this.contacts_list.filter(data=> data.id == e.go_marketing)
          go_marketing = go_marketing && go_marketing.length? go_marketing[0] : null
        }
        if(e.go_ops){
          go_ops = this.contacts_list.filter(data => data.id == e.go_ops)
          go_ops = go_ops && go_ops.length? go_ops[0] : null
        }
      }

      let obj = {
        date: e.disable_date,
        index: this.index,
        selected: e,
        annual_goal:e.annual_goal,
        active:e.active,
        country_code:e.country_code,
        prev_go_client_id:e.go_client_id,
        partner_uuid: e.partner_uuid,
        go_retail:go_retail,
        go_marketing:go_marketing,
        go_ops:go_ops
      };
      this.$emit("vendorUpdated", obj);
    },
    addNewVendor(){
      let indx = this.index;
      this.$emit("openVendorPopUp", indx);
    
    },
    pushVendorToVendor(data, type) {
      let indx = this.index;
      this.$emit("openVendorPopUp", data, type, indx);
    },
    // removeSelectedVendor() {
    //   this.$emit("removeSelected", "vendor", this.index);
    // },
  },
};
</script>